import * as globals from '@wandb/common/css/globals.styles';
import styled, {css} from 'styled-components';

import {SectionColumn} from './Section.styles';

export const OnboardingContainer = styled.div`
  margin-bottom: 32px;

  @media (max-width: 520px) {
    margin-bottom: 24px;
  }
`;

export const HomeHeader = styled.div`
  text-align: center;
  margin-bottom: 36px;

  @media (max-width: 768px) {
    margin-top: 24px;
  }

  @media (max-width: 520px) {
    margin-top: 8px;
    margin-bottom: 24px;
  }
`;

const HomeHeaderText = styled.h1`
  max-width: 480px;
  margin: 0 auto;
`;

export const HomeHeaderMainText = styled(HomeHeaderText as any)`
  font-size: 32px;

  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

export const HomeHeaderSubText = styled(HomeHeaderText as any)`
  font-size: 20px;
  margin-top: 16px;
  line-height: 32px;

  @media (max-width: 520px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const HomePageSectionColumn = styled(SectionColumn)`
  @media (min-width: ${globals.TABLET_WIDTH + 1}px) {
    &:nth-child(1) {
      width: 312px;
    }

    &:nth-child(2) {
      width: 576px;
    }
  }
`;

export const StartGuide = styled.div<{isMobile?: boolean; embedded?: boolean}>`
  padding: ${props => (props.isMobile ? '16px 16px' : '32px 32px')} 8px;
  max-width: 920px;
  background: white;
  ${p =>
    !p.embedded &&
    css`
      border: 1px solid ${globals.gray300};
    `}
  border-radius: 3px;

  h1 {
    font-weight: 600;
    font-size: ${props => (props.isMobile ? '24' : '30')}px;
    padding: 0;
    margin: 0;
    margin-bottom: 8px;
  }

  h2 {
    font-weight: 400;
    font-size: 16px;
    padding: 0;
    margin: 0;
    margin-bottom: 16px;
  }
`;

export const StartGuideSectionHeader = styled.div<{
  active?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;

  div:first-child {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    padding-bottom: 2px;
    color: ${props => (props.active ? 'white' : `${globals.primary}`)};
    background: ${props => (props.active ? `${globals.primary}` : 'white')};
    border-radius: 20px;
    border: 1px solid ${globals.primary};
  }

  div:nth-child(2) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    span {
      display: flex;
      font-weight: normal;
    }
  }
`;

export const StartGuideSectionSubheader = styled.div`
  margin-bottom: 8px;
`;

export const StartGuideSection = styled.div`
  img {
    width: 100%;
    border: 1px solid ${globals.gray300};
    border-radius: 6px;
    transition: filter 0.1s linear;

    &:hover {
      filter: brightness(95%);
    }
  }
`;

export const StartGuideSectionContainer = styled.div<{border?: boolean}>`
  margin-left: 14px;
  padding: 6px 0 24px 20px;

  & > div:first-child {
    position: relative;
    left: -32px;
    top: -6px;
  }

  ${props =>
    props.border &&
    css`
      border-left: 1px solid ${globals.primaryBorder};
    `}
`;
